export default "__VITE_ASSET__DY$sM1kj__"